// The tabular readouts — the costs table, the rollout board, a standings list.
//
// **Descendant selectors rather than styled `Th`/`Td`.** A table's markup is
// already the structure; making a call site import five components to write a
// row buys nothing and loses the ability to paste a table in whole. The header
// is the display voice because it labels a column, which is the same job
// `SectionTitle` does.

import { styled } from "@mui/material/styles";

export const Table = styled("table")(({ theme }) => ({
  borderCollapse: "collapse",
  width: "100%",
  fontFamily: theme.kit.font.body,
  fontSize: 13,
  color: theme.kit.color.ink,

  "& th": {
    fontFamily: theme.kit.font.display,
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: ".6px",
    textTransform: "uppercase",
    color: theme.kit.color.inkDim,
    textAlign: "left",
    padding: "6px 8px",
    borderBottom: `2px solid ${theme.kit.color.line}`
  },
  "& td": {
    padding: "6px 8px",
    borderBottom: `1px solid ${theme.kit.color.line}`,
    verticalAlign: "top"
  },
  "& tr:last-child td": { borderBottom: 0 }
}));

/** A table wider than its column scrolls itself; the page never does. */
export const TableScroll = styled("div")({ overflowX: "auto" });
